import React, { useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import '../Global.css';
import api from '../api';
const CreateTournament = () => {
    const categories = ["Müzik", "Spor", "Para", "Eğlence", "Genel Kültür", "Sinema & Dizi", "Music", "Sports", "Money", "Fun", "General", "Movies and Shows"];
    const types = ["standart", "top-artist"];
    
    const [apiNo, setApiNo] = useState("");
    const [cekilecekMiktar, setCekilecekMiktar] = useState(64);

    // Tekil "title" ve "language" yerine, çoklu dil state'leri eklendi
    const [formData, setFormData] = useState({
        category: '',
        type: 'standart',
        image: '',
        visibility: "public",
        platform: "quizei",
        // Çoklu Dil Alanları
        isTurkishOpen: false,
        turkishTitle: '',
        isEnglishOpen: true, // Varsayılan olarak İngilizce açık gelsin
        englishTitle: '',
        isPolishOpen: false,
        polishTitle: ''
    });

    const [decisions, setDecisions] = useState([
        { title: '', image: '', winAmount: 0 },
        { title: '', image: '', winAmount: 0 }
    ]);

    // Checkbox ve normal inputları aynı anda yönetmek için güncellendi
    const handleInputChange = (e) => {
        const { name, type, checked, value } = e.target;
        setFormData({ 
            ...formData, 
            [name]: type === 'checkbox' ? checked : value 
        });
    };

    // React Admin Paneli - Gönderim Fonksiyonu (Uwufufu / Quizei Import)
    const handleUwufufuImport = async () => {
        // Frontend validasyonu: En az bir dil seçili olmalı
        if (!formData.isTurkishOpen && !formData.isEnglishOpen && !formData.isPolishOpen) {
            return alert("Lütfen import için en az bir dil seçin ve başlığını girin!");
        }

        try {
            const payload = {
                ...formData,
                uwufufuId: apiNo,
                cekilecekMiktar
            };
            
            let importUrl = formData.platform === "uwufufu" 
                ? `/v1/admin/import` 
                : `/v1/admin/import/quizei`;

            const res = await api.post(
                importUrl,
                payload,
                { headers: { Authorization: `Bearer ${localStorage.getItem('JWTTOKEN')}` } }
            );

            if (res.data.status === "success") {
                // Backend artık "slug" yerine "slugs" dizisi dönüyor
                alert(`Harika! ${res.data.slugs.length} dilde turnuva oluşturuldu.\nSluglar:\n${res.data.slugs.join('\n')}`);
            }
        } catch (error) {
            console.error("Import hatası:", error);
            alert("Turnuva yüklenirken bir hata oluştu: " + (error.response?.data?.message || "Bilinmeyen Hata"));
        }
    };

    // Dosya Yükleme Fonksiyonu
    const handleFileUpload = async (e, target, index = null) => {
        const file = e.target.files[0];
        if (!file) return;

        const uploadData = new FormData();
        uploadData.append('file', file);

        try {
            const response = await api.post('/v1/util/uploadImage', uploadData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${localStorage.getItem('JWTTOKEN')}`
                }
            });

            const BASE_URL = "https://images.turnaments.com";
            const uploadedPath = BASE_URL + response.data.data.filePath;

            if (target === 'main') {
                setFormData(prev => ({ ...prev, image: uploadedPath }));
            } else if (target === 'decision') {
                const newDecisions = [...decisions];
                newDecisions[index].image = uploadedPath;
                setDecisions(newDecisions);
            }
        } catch (err) {
            alert("Yükleme hatası: " + (err.response?.data?.message || "Sunucuya ulaşılamadı"));
        }
    };

    const handleDecisionChange = (index, e) => {
        const newDecisions = [...decisions];
        newDecisions[index][e.target.name] = e.target.value;
        setDecisions(newDecisions);
    };

    const addDecision = () => {
        setDecisions([...decisions, { title: '', image: '', winAmount: 0 }]);
    };

    const removeDecision = (index) => {
        if (decisions.length <= 2) return alert("En az 2 seçenek olmalı!");
        const newDecisions = decisions.filter((_, i) => i !== index);
        setDecisions(newDecisions);
    };

    // Manuel Turnuva Oluşturma Gönderimi
    const handleSubmit = async (e) => {
        e.preventDefault();
        const tournamentData = { ...formData, decisions };

        try {
            const response = await api.post('/v1/tournament/', tournamentData, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('JWTTOKEN')}` }
            });
            if (response.data.status === 'success') {
                alert('Turnuva başarıyla oluşturuldu!');
                window.location.href = "/";
            }
        } catch (err) {
            alert('Hata: ' + (err.response?.data?.message || 'Bir sorun oluştu'));
        }
    };

    // Gerekli stil objesi (Eksik olmaması için basitçe ekledim, projendeki stilleri kullanabilirsin)


    return (
        <div className="app-container">
            <Navbar />
            <div className="main-content">
                <h2 style={styles.header}>Yeni Turnuva Oluştur & İmport</h2>

                <form onSubmit={handleSubmit}>
                    
                    {/* DİL VE BAŞLIK SEÇİMİ (YENİ EKLENEN BÖLÜM) */}
                    <div style={styles.card}>
                        <h4 style={styles.cardHeader}>Diller ve Başlıklar</h4>
                        <p style={{fontSize: '13px', color: 'gray', marginBottom: '15px'}}>Turnuvanın hangi dillerde oluşturulmasını istiyorsanız o dili aktif edip başlığını girin.</p>

                        {/* İngilizce */}
                        <div style={{ display: 'flex', gap: '15px', alignItems: 'center', marginBottom: '10px' }}>
                            <input type="checkbox" name="isEnglishOpen" checked={formData.isEnglishOpen} onChange={handleInputChange} style={{ width: '20px', height: '20px' }} />
                            <label style={{ fontWeight: 'bold', width: '120px' }}>İngilizce (EN)</label>
                            {formData.isEnglishOpen && (
                                <input name="englishTitle" value={formData.englishTitle} onChange={handleInputChange} style={styles.input} placeholder="English Title..." required={formData.isEnglishOpen} />
                            )}
                        </div>

                        {/* Türkçe */}
                        <div style={{ display: 'flex', gap: '15px', alignItems: 'center', marginBottom: '10px' }}>
                            <input type="checkbox" name="isTurkishOpen" checked={formData.isTurkishOpen} onChange={handleInputChange} style={{ width: '20px', height: '20px' }} />
                            <label style={{ fontWeight: 'bold', width: '120px' }}>Türkçe (TR)</label>
                            {formData.isTurkishOpen && (
                                <input name="turkishTitle" value={formData.turkishTitle} onChange={handleInputChange} style={styles.input} placeholder="Türkçe Başlık..." required={formData.isTurkishOpen} />
                            )}
                        </div>

                        {/* Lehçe */}
                        <div style={{ display: 'flex', gap: '15px', alignItems: 'center', marginBottom: '10px' }}>
                            <input type="checkbox" name="isPolishOpen" checked={formData.isPolishOpen} onChange={handleInputChange} style={{ width: '20px', height: '20px' }} />
                            <label style={{ fontWeight: 'bold', width: '120px' }}>Lehçe (PL)</label>
                            {formData.isPolishOpen && (
                                <input name="polishTitle" value={formData.polishTitle} onChange={handleInputChange} style={styles.input} placeholder="Polski Tytuł..." required={formData.isPolishOpen} />
                            )}
                        </div>
                    </div>

                    {/* GENEL BİLGİLER */}
                    <div style={styles.card}>
                        <h4 style={styles.cardHeader}>Genel Bilgiler</h4>

                        <div style={{ display: 'flex', gap: '20px' }}>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Kategori</label>
                                <select name="category" onChange={handleInputChange} style={styles.select}>
                                    <option value="">Seçiniz...</option>
                                    {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                                </select>
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Tür</label>
                                <select name="type" onChange={handleInputChange} style={styles.select}>
                                    {types.map(t => <option key={t} value={t}>{t}</option>)}
                                </select>
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Görünürlük</label>
                                <select name="visibility" value={formData.visibility} onChange={handleInputChange} style={styles.select}>
                                    <option value="public">Public</option>
                                    <option value="unlisted">Unlisted</option>
                                </select>
                            </div>
                        </div>

                        <label style={{ ...styles.label, marginTop: '15px' }}>Ortak Kapak Görseli (Boş bırakılırsa ilk resim atanır)</label>
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                            <input type="text" value={formData.image} placeholder="Dosya URL..." style={styles.input} readOnly />
                            <label style={styles.uploadBtn}>
                                Dosya Seç
                                <input type="file" style={{ display: 'none' }} onChange={(e) => handleFileUpload(e, 'main')} />
                            </label>
                        </div>
                        {formData.image && <img src={formData.image} alt="preview" style={styles.preview} />}
                    </div>

                    {/* IMPORT BÖLÜMÜ */}
                    <div style={styles.card}>
                        <h4 style={styles.cardHeader}>API'den Turnuva İmport Et</h4>
                        <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-end' }}>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Turnuva ID</label>
                                <input name="turnuva_id" onChange={(t) => setApiNo(t.target.value)} style={styles.input} placeholder="Örn: 165984" />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Çekilecek Miktar (Limit)</label>
                                <input name="miktar" value={cekilecekMiktar} onChange={(t) => setCekilecekMiktar(t.target.value)} style={styles.input} placeholder="64" />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Platform</label>
                                <select name="platform" value={formData.platform} onChange={handleInputChange} style={styles.select}>
                                    <option value="quizei">Quizei</option>
                                    <option value="uwufufu">Uwufufu</option>
                                </select>
                            </div>
                            <div style={{ flex: 1 }}>
                                <button type="button" onClick={handleUwufufuImport} style={{ ...styles.uploadBtn, width: '100%', marginBottom: '10px' }}>
                                    İmport Başlat
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* MANUEL SEÇENEKLER */}
                    <div style={{ marginTop: '30px' }}>
                        <h4 style={styles.cardHeader}>Manuel Seçenekler (Decisions) - Import Edilmiyorsa</h4>
                        {decisions.map((decision, index) => (
                            <div key={index} style={styles.decisionCard}>
                                <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-end' }}>
                                    <div style={{ flex: 2 }}>
                                        <label style={styles.label}>Seçenek #{index + 1} Başlığı</label>
                                        <input name="title" value={decision.title} onChange={(e) => handleDecisionChange(index, e)} style={styles.input} />
                                    </div>
                                    <div style={{ flex: 3 }}>
                                        <label style={styles.label}>Görsel</label>
                                        <div style={{ display: 'flex', gap: '5px' }}>
                                            <input value={decision.image} style={styles.input} readOnly placeholder="URL..." />
                                            <label style={styles.uploadBtnSmall}>
                                                Yükle
                                                <input type="file" style={{ display: 'none' }} onChange={(e) => handleFileUpload(e, 'decision', index)} />
                                            </label>
                                        </div>
                                    </div>
                                    <button type="button" onClick={() => removeDecision(index)} style={styles.deleteBtn}>Sil</button>
                                </div>
                            </div>
                        ))}

                        <div style={styles.actions}>
                            <button type="button" onClick={addDecision} style={styles.addBtn}>
                                + Yeni Seçenek Ekle
                            </button>
                            <button type="submit" style={styles.submitBtn}>
                                Manuel Turnuvayı Yayınla
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};



const styles = {
    header: { color: 'white', marginBottom: '30px' },
    card: { backgroundColor: '#121212', padding: '20px', borderRadius: '15px', border: '1px solid #252525', marginTop: 20 },
    cardHeader: { color: '#029220', marginBottom: '20px' },
    label: { color: '#b3b3b3', display: 'block', marginBottom: '5px', fontSize: '14px' },
    input: { backgroundColor: '#1e1e1e', color: 'white', border: '1px solid #333', padding: '10px', borderRadius: '8px', width: '100%', marginBottom: '10px' },
    select: { backgroundColor: '#1e1e1e', color: 'white', border: '1px solid #333', padding: '10px', borderRadius: '8px', width: '100%' },
    decisionCard: { backgroundColor: '#181818', padding: '15px', borderRadius: '10px', border: '1px solid #252525', marginBottom: '10px' },
    uploadBtn: { backgroundColor: '#029220', color: 'white', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', height: '42px', display: 'flex', alignItems: 'center' },
    uploadBtnSmall: { backgroundColor: '#333', color: 'white', padding: '0 15px', borderRadius: '8px', cursor: 'pointer', height: '42px', display: 'flex', alignItems: 'center' },
    preview: { width: '100px', height: '100px', borderRadius: '10px', objectFit: 'cover', marginBottom: '10px' },
    deleteBtn: { backgroundColor: '#331111', color: '#ff4d4d', border: '1px solid #442222', padding: '10px', borderRadius: '8px', height: '42px', marginBottom: '10px' },
    actions: { display: 'flex', gap: '20px', marginTop: '30px', paddingBottom: '50px' },
    addBtn: { flex: 1, backgroundColor: 'transparent', color: '#029220', border: '1px solid #029220', padding: '15px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' },
    submitBtn: { flex: 2, backgroundColor: '#029220', color: 'white', border: 'none', padding: '15px', borderRadius: '10px', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer' }
};


export default CreateTournament;